import { QueryLabelInfo, RangeInfo } from 'src/app/shared/models';
import { YearsRangeInfo } from '../../data';

export class YearsRangeInfoFilterQueryItem {
  constructor(public data: RangeInfo) {}

  private separator = '_';
  private MAX_YEAR = YearsRangeInfo.getMaxYear();
  private MIN_YEAR = YearsRangeInfo.MIN_YEAR;

  doesHaveAnyValue(): boolean {
    return this.data?.start > this.MIN_YEAR || this.data?.finish !== this.MAX_YEAR;
  }

  getContentString(): string {
    let filter = '';

    if (this.data) {
      if (this.data.start === this.MIN_YEAR && this.data.finish === this.MAX_YEAR) {
        return filter;
      }

      filter =
        this.data.start === this.MAX_YEAR || this.data.finish === null
          ? `${this.data?.start}`
          : `${this.data?.start}${this.separator}${this.data?.finish}`;
    }

    return filter;
  }

  setDataFromSearchLine(searchItem: string): void {
    if (searchItem?.length && this.data && this.separator) {
      const itemList: string[] = searchItem?.split(this.separator);

      if (itemList?.length && Array?.isArray(itemList)) {
        const start: string = itemList[0];
        const finish: string = itemList[1];

        if (start) {
          this.data.start = Number?.parseInt(start, 0);
        }

        if (finish) {
          this.data.finish = Number?.parseInt(finish, 0);
        }
      } else {
        this.data.start = Number?.parseInt(searchItem, 0);
        this.data.finish = this.MAX_YEAR;
      }
    }
  }

  getLabelInfo(): QueryLabelInfo {
    const label: string = this.getFullLabel();

    return label ? { value: label } : null;
  }

  getFullLabel(): string {
    const { start, finish } = this.data;

    return start === this.MIN_YEAR && finish === this.MAX_YEAR ? null : `${start} - ${finish}`;
  }
}
